import React from 'react';
import { DivIcon } from '../icons';
import SidebarTool from './SidebarTool';
import { StageMode } from '../editor';

const ButtonDivTool = () => <SidebarTool tool={StageMode.div} icon={DivIcon} />;

export default ButtonDivTool;
